<template>
  <div class="navStyle">
    <div class="nav-up">
      <div class="up-left">
        <shrink :isCollapse="isCollapse" @toggleClick="toggleSideBar"></shrink>
        <BreadCrumb></BreadCrumb>
      </div>
      <div class="up-right">
        <el-select v-model="myVal" @change="changeLanguage" class="leftBack-select">
          <el-option v-for="item in language" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <i :class="this.iFullScreen
            ? 'iconfont iconchuangkouhuanyuan'
            : 'iconfont iconfangda'
          " :title="$t('HomPage.toggleFullScreen')" @click="toggleFullScreen">
        </i>
        <i class="iconfont iconwenhao"></i>
        <!-- <el-badge :value="count" class="item">
          <i class="el-icon-bell" @click="btnRemind" v-if="show"></i>
        </el-badge> -->

        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link" style="color: white">
            <i class="right-head"></i>{{ user }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a" @click="changePass()">{{
              $t("TopBar.pass")
            }}</el-dropdown-item>
            <el-dropdown-item command="b">{{
              $t("TopBar.exit")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dialog :title="$t('TopBar.pass')" :visible.sync="dialogFormVisible" class="menuDialog"
          :close-on-click-modal="false">
          <el-form :model="form" ref="form" :rules="rules">
            <el-form-item :label="$t('TopBar.oldPass')" :label-width="formLabelWidth" prop="oldPwd">
              <el-input type="password" v-model="form.oldPwd" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('TopBar.newPass')" :label-width="formLabelWidth" prop="loginPwd">
              <el-input type="password" v-model="form.loginPwd" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('TopBar.form.confirmPass')" :label-width="formLabelWidth" prop="checkPass">
              <el-input type="password" v-model="form.checkPass" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogFormVisible = false">{{
              $t("common.btn.cancel")
            }}</el-button>
            <el-button size="small" type="primary" @click="submitForm('form')">{{ $t("common.btn.confirm")
              }}</el-button>
          </div>
        </el-dialog>
        <el-dialog width="1200px" :title="$t('TopBar.message')" :visible.sync="dialogRemindVisible" class="menuDialog"
          :close-on-click-modal="false">
          <div class="dialogNotice">
            <!-- <div class="noticeConfig">
              <el-button @click="ListSetting" type="text">{{
                $t("TopBar.btn.selfSet")
              }}</el-button>
              <i-column
                :listData="listData"
                @changeSort="changeSort"
                v-on:changeCheck="changeCheck"
                v-on:draggerEnd="draggerEnd"
                ref="listSet"
              >
              </i-column>
              <div class="configFlex">
                <div
                  v-for="(item, index) in configList"
                  :key="index"
                  class="flexStyle"
                >
                  <div class="flexValue">{{ item.value }}</div>
                  <div class="flexName">{{ item.profileName }}</div>
                </div>
              </div>
            </div> -->
            <div class="noticeTab">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane name="first">
                  <span slot="label">{{ $t('VehicleManagement.PendingRepairRequest') }}<span
                      style="color:#F56C6C">({{ repairTotal }})</span></span>
                </el-tab-pane>
                <el-tab-pane name="second">
                  <span slot="label">{{ $t('VehicleManagement.PendingProcessingViolations') }}<span
                      style="color:#F56C6C">({{ violationTotal }})</span></span>
                </el-tab-pane>
                <el-tab-pane name="third">
                  <span slot="label">{{ $t('VehicleManagement.PendingFault') }}<span
                      style="color:#F56C6C">({{ faultTotal }})</span></span>
                </el-tab-pane>
                <div class="zMsgSearch">
                  <el-form :inline="true" :model="formTable" class="demo-form-inline">
                    <div v-if="activeName == 'first'">
                      <el-form-item :label="$t('common.num')">
                        <el-select v-model="formTable.selectCarType" style="width: 120px"
                          :placeholder="$t('common.choseTip')" class="selectStyle">
                          <el-option v-for="item in optionsInput" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <el-input size="mini" v-model="formTable.selectCarValue" :placeholder="$t('common.searchTip')"
                          style="width: 150px" class="inputStyle"></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('TopBar.happenTime')">
                        <el-date-picker v-model="formTable.MaintainTime" type="datetimerange" style="width: 220px"
                          size="mini" value-format="yyyy-MM-dd HH:mm:ss" range-separator
                          :start-placeholder="$t('common.choseTime')" end-placeholder></el-date-picker>
                      </el-form-item>
                      <el-form-item>
                        <el-button size="mini" type="primary" @click="Search" class="btn-chaxun">{{
                          $t("common.btn.search") }}</el-button>
                        <el-button size="mini" @click="Clear" class="btn-del">{{
                          $t("common.btn.cancel")
                        }}</el-button>
                      </el-form-item>
                    </div>
                    <div v-if="activeName == 'second'">
                      <el-form-item :label="$t('TopBar.driverNumOrDriverName')">
                        <el-input size="mini" v-model="formTable.number" :placeholder="$t('common.searchTip')"
                          style="width: 150px" class="input-with-select"></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('TopBar.violationType')">
                        <el-select v-model="formTable.eventCode" :placeholder="$t('TopBar.violationType')" filterable
                          size="mini" style="width: 120px">
                          <el-option v-for="item in violationList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :label="$t('TopBar.violationTime')">
                        <el-date-picker v-model="formTable.FaultTime" type="daterange" style="width: 220px" size="mini"
                          value-format="yyyy-MM-dd" range-separator :start-placeholder="$t('common.btn.choseDate')"
                          end-placeholder></el-date-picker>
                      </el-form-item>
                      <el-form-item>
                        <el-button size="mini" type="primary" @click="Search" class="btn-chaxun">{{
                          $t("common.btn.search") }}</el-button>
                        <el-button size="mini" @click="Clear" class="btn-del">{{
                          $t("common.btn.cancel")
                        }}</el-button>
                      </el-form-item>
                    </div>
                    <div v-if="activeName == 'third'">
                      <el-form-item :label="$t('TopBar.carIdOrManufactureNum')">
                        <el-input size="mini" v-model="formTable.number" :placeholder="$t('common.searchTip')"
                          style="width: 150px" class="input-with-select"></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('TopBar.faultType')">
                        <el-select v-model="formTable.eventCode" :placeholder="$t('TopBar.faultType')" filterable
                          size="mini" style="width: 120px">
                          <el-option v-for="item in faultList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :label="$t('TopBar.faultTime')">
                        <el-date-picker v-model="formTable.FaultTime" type="daterange" style="width: 220px" size="mini"
                          value-format="yyyy-MM-dd" range-separator :start-placeholder="$t('common.btn.choseDate')"
                          end-placeholder></el-date-picker>
                      </el-form-item>
                      <el-form-item>
                        <el-button size="mini" type="primary" @click="Search" class="btn-chaxun">{{
                          $t("common.btn.search") }}</el-button>
                        <el-button size="mini" @click="Clear" class="btn-del">{{
                          $t("common.btn.cancel")
                        }}</el-button>
                      </el-form-item>
                    </div>

                  </el-form>
                </div>
                <div>
                  <div v-if="this.activeName == 'first'" style="float: right">
                    <el-button v-if="isPrimaryKey('REPAIRFORM_REMINDER')" type="text" :disabled="selected.length != 1"
                      @click="deleteRepair">{{
                        $t("common.acceptOrders")
                      }}</el-button>
                  </div>
                  <div class="zMsgBtn" v-else>
                    <div class="btnLeft">
                      <span class="btnStyle" v-for="(btn, index) in btnList" :key="index" @click="changeBtn(index)">
                        <span :class="{ btnBackground: changeBackground === index }"><i :class="btn.icon"></i>{{
                          btn.name }}<span style="padding-right: 0;" v-if="index == 0">({{ total }})</span></span>
                      </span>
                    </div>
                    <div class="btnRight">
                      <el-button type="text" v-if="selectType == 0" :disabled="selected.length == 0"
                        @click="btnIgnore('all')">{{ $t("TopBar.btn.ignore") }}</el-button>
                      <el-button type="text" @click="down">{{
                        $t("common.btn.download")
                      }}</el-button>
                    </div>
                  </div>
                </div>
                <div class="zMsgTable">
                  <i-table :list="authorizeList" :height="authorizeHeight" ref="authorizeTable"
                    @handleSelectionChange="handleAuthorizeChange" :options="option" :columns="AllColumns"
                    :operates="authorizeOperates"></i-table>
                  <IPagination ref="AuthorizePage" @PageFun="changeAuthorizeSize"></IPagination>
                </div>
              </el-tabs>
            </div>
          </div>
        </el-dialog>
        <el-dialog width="620px" :before-close="closeDia" class="privateDialong" :title="diaTitle"
          :visible.sync="dialogAddVisible" :close-on-click-modal="false" append-to-body>
          <el-form :rules="addRules" ref="addForm" :model="addForm">
            <el-form-item prop="carId" :label="$t('common.carId') + ':'" :label-width="formLabelWidth">
              <el-input disabled size="small" v-model="addForm.carId" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="contactName" :label="$t('TopBar.contactName') + ':'" :label-width="formLabelWidth">
              <el-input size="small" v-model="addForm.contactName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="happenTime" :label="$t('TopBar.happenTime') + ':'" :label-width="formLabelWidth">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                :placeholder="$t('common.btn.choseDate')" v-model="addForm.happenTime"></el-date-picker>
            </el-form-item>
            <el-form-item prop="phone" :label="$t('TopBar.phone') + ':'" :label-width="formLabelWidth">
              <el-input size="small" v-model="addForm.phone" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="remarks" :label="$t('TopBar.describe') + ':'" :label-width="formLabelWidth">
              <el-input size="small" v-model="addForm.remarks" autocomplete="off" type="textarea" :rows="2"></el-input>
            </el-form-item>
            <el-form-item prop="filePath" :label="$t('common.btn.uploadPicture')" :label-width="formLabelWidth"
              style="margin-top: 20px">
              <el-upload class="avatar-uploader" :action="processImg" list-type="picture-card" :file-list="FileList"
                :limit="4" :on-success="handleAvatarSuccess" :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" append-to-body class="imgForm">
                <img width="100%" :src="imageUrl" alt="" class="avatar" />
              </el-dialog>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="cancle('addForm')">{{
              $t("common.btn.cancel")
            }}</el-button>
            <el-button size="small" type="primary" @click="submitAdd('addForm')">{{ $t("common.btn.confirm")
              }}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="nav-down">
      <tagView></tagView>
    </div>
  </div>
</template>

<script>
import shrink from "../../layout/navMenu/plugin/shrink.vue";
import BreadCrumb from "../../layout/navMenu/plugin/BreadCrumb.vue";
import tagView from "../../layout/navMenu/plugin/tagView.vue";
import screenfull from "screenfull";
import iTable from "../../components/Table.vue";
import IPagination from "../../components/pagination.vue";
import IColumn from "../../components/Column.vue";
import Btn from "./plugin/btn.vue";
import { domainName, processApi } from "../../utility/index";
import moment from "moment-timezone";
import { getCurrentTimezone } from "../../utils/timezoneHelper";
import VueWebSocket from 'vue-websocket';

export default {
  components: {
    shrink,
    BreadCrumb,
    tagView,
    iTable,
    IPagination,
    IColumn,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("Login.loginPwdMessage")));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("TopBar.form.imputPassAgain")));
      } else if (value !== this.form.loginPwd) {
        callback(new Error(this.$t("TopBar.form.passDifferent")));
      } else {
        callback();
      }
    };
    return {
      iFullScreen: false,
      isCollapse: false,
      myVal: 0,
      language: [
        { label: this.$t("TopBar.en"), value: 1 },
        { label: this.$t("TopBar.zh"), value: 0 },
      ],
      dialogFormVisible: false,
      form: {
        loginPwd: "",
        oldPwd: "",
        checkPass: "",
      },
      rules: {
        loginPwd: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      formLabelWidth: "120px",
      user: "",
      imgLogo: "",
      dialogRemindVisible: false,
      activeName: "first",
      formTable: {
        number: "",
        eventCode: "",
        FaultTime: [],
        selectCarType: '',
        selectCarValue: '',
        MaintainTime: [],
      },
      optionsInput: [{
        value: '0',
        label: this.$t('common.all')
      }, {
        value: '1',
        label: this.$t('common.carId')
      }, {
        value: '2',
        label: this.$t('common.plateNum')
      }, {
        value: '3',
        label: this.$t('common.customNum')
      },
      {
        value: '4',
        label: this.$t('common.manufactureNum')
      }],
      violationList: [],
      faultList: [],
      isShow: true,
      isDisplay: true,
      authorizeList: [],
      authorizeHeight: "350px",
      stateId: "",
      AllColumns: [],
      FaultColumns: [
        {
          prop: "carId",
          label: this.$t("common.carId"),
          align: "center",
          width: "220px",
        },
        {
          prop: "manufactureNum",
          label: this.$t("common.manufactureNum"),
          align: "center",
          width: "220px",
        },
        {
          prop: "eventMessage",
          label: this.$t("TopBar.faultType"),
          align: "center",
          width: "220px",
        },
        {
          prop: "startTime",
          label: this.$t("TopBar.startTime"),
          align: "center",
          width: "280px",
        },
        {
          prop: "handleState",
          label: this.$t("TopBar.handleState"),
          align: "center",
          width: "220px",
          render: (h, params) => {
            return h(
              "el-tag",
              {
                props: {
                  type:
                    params.row.handleState == null
                      ? ""
                      : params.row.handleState == 0
                        ? "warning"
                        : params.row.handleState == 1
                          ? "success"
                          : "info",
                },
              },
              params.row.handleState == null
                ? ""
                : params.row.handleState == 0
                  ? this.$t("TopBar.noHandle")
                  : params.row.handleState == 1
                    ? this.$t("TopBar.handle")
                    : this.$t("TopBar.ignored")
            );
          },
        },
        {
          prop: "state",
          label: this.$t("common.btn.operate"),
          align: "center",
          width: "160px",
          render: (h, params) => {
            return h(Btn, {
              props: {
                list: this.faultsList,
                item: params,
              },
              on: {
                clickBtn: (row) => {
                  console.log(params.row);
                  this.stateId = params.row.id;
                  if (row.filed == "begin") {
                    this.btnIgnore("one");
                  } else {
                    this.dialogAddVisible = true;
                    this.diaTitle = this.$t("common.btn.add");
                    this.btnType = "add";
                    this.FileList = [];
                    this.addForm.carId = params.row.carId
                    this.addForm.contactName =
                      sessionStorage.getItem("username");
                    const timezone = getCurrentTimezone();
                    this.addForm.happenTime = moment().tz(timezone).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    this.$nextTick(() => {
                      this.$refs.addForm.resetFields();
                    });
                  }
                },
              },
            });
          },
        },
      ],
      faultsList: [
        {
          label: this.$t("TopBar.btn.ignore"),
          type: "primary",
          filed: "begin",
        },
        { label: this.$t("TopBar.repair"), type: "primary", filed: "repair" },
      ],
      ViolationColumns: [
        {
          prop: "driverNum",
          label: this.$t("common.driverNum"),
          align: "center",
          width: "220px",
        },
        {
          prop: "driverName",
          label: this.$t("common.driverName"),
          align: "center",
          width: "220px",
        },
        {
          prop: "eventMessage",
          label: this.$t("TopBar.violationType"),
          align: "center",
          width: "220px",
        },
        {
          prop: "startTime",
          label: this.$t("TopBar.startTime"),
          align: "center",
          width: "280px",
        },
        {
          prop: "handleState",
          label: this.$t("TopBar.handleState"),
          align: "center",
          width: "220px",
          render: (h, params) => {
            return h(
              "el-tag",
              {
                props: {
                  type:
                    params.row.handleState == null
                      ? ""
                      : params.row.handleState == 0
                        ? "warning"
                        : params.row.handleState == 1
                          ? "success"
                          : "info",
                },
              },
              params.row.handleState == null
                ? ""
                : params.row.handleState == 0
                  ? this.$t("TopBar.noHandle")
                  : params.row.handleState == 1
                    ? this.$t("TopBar.handle")
                    : this.$t("TopBar.ignored")
            );
          },
        },
        {
          prop: "state",
          label: this.$t("common.btn.operate"),
          align: "center",
          width: "160px",
          render: (h, params) => {
            return h(Btn, {
              props: {
                list: this.violaList,
                item: params,
              },
              on: {
                clickBtn: (row) => {
                  console.log(row);
                  this.stateId = params.row.id;
                  if (row.filed == "begin") {
                    this.btnIgnore("one");
                  } else {
                    this.btnPush();
                  }
                },
              },
            });
          },
        },
      ],
      violaList: [
        {
          label: this.$t("TopBar.btn.ignore"),
          type: "primary",
          filed: "begin",
        },
        { label: this.$t("TopBar.push"), type: "primary", filed: "push" },
      ],
      repairColumns: [
        {
          prop: "requestSerialNumber",
          label: this.$t('VehicleManagement.serialNumber'),
          align: "center",
          width: "180px"
        },
        {
          prop: "carId",
          label: this.$t('common.carId'),
          align: "center",
        },
        {
          prop: "manufactureNum",
          label: this.$t('common.manufactureNum'),
          align: "center",
          width: "150px"
        },
        {
          prop: "customNum",
          label: this.$t('common.customNum'),
          align: "center",
          width: "120px"
        },
        {
          prop: "plateNum",
          label: this.$t('common.plateNum'),
          align: "center",
          width: "120px"
        },
        {
          prop: "orgName",
          label: this.$t('common.orgName'),
          align: "center",
          width: "120px"
        },
        {
          prop: "carWorkTime",
          label: this.$t('VehicleManagement.carWorkTime'),
          align: "center",
          width: "160px"

        },
        {
          prop: "contactName",
          label: this.$t('VehicleManagement.repairPerson'),
          align: "center",
          width: "120px"
        },

        {
          prop: "happenTime",
          label: this.$t('TopBar.happenTime'),
          align: "center",
          width: "200px"
        },
        {
          prop: "phone",
          label: this.$t('TopBar.phone'),
          align: "center",
          width: "160px"
        },
        {
          prop: "urgeCount",
          label: this.$t('VehicleManagement.urgeCount'),
          align: "center",
          width: "120px"
        },
        {
          prop: "repairState",
          label: this.$t('common.repairStatus'),
          align: "center",
          width: "120px",
          render: (h, params) => {
            return h('el-tag', {
              props: { type: params.row.repairState === '' ? '' : params.row.repairState === 0 ? 'danger' : params.row.repairState === 1 ? 'warning' : params.row.repairState === 2 ? 'success' : 'info' }
            }, params.row.repairState === '' ? '' : params.row.repairState === 0 ? this.$t('VehicleManagement.unaccepted') : params.row.repairState === 1 ? this.$t('VehicleManagement.repaired') : params.row.repairState === 2 ? this.$t('VehicleManagement.alreadyRepaired') : this.$t('VehicleManagement.closed'))
          }

        }
      ],
      repairList: [],
      authorizeOperates: {
        width: 160,
        fixed: "right",
        list: [],
      },
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: true,
        serialNumber: true,
      },
      AuthorizeCurrentPage: 1,
      AuthorizePageSize: 10,
      AuthorizeTotal: 1,

      btnList: [
        { icon: "el-icon-warning", name: this.$t("TopBar.noHandle") },
        { icon: "el-icon-success", name: this.$t("TopBar.handle") },
        { icon: "el-icon-error", name: this.$t("TopBar.ignored") },
      ],
      changeBackground: 0,
      selectType: 0,
      selected: [],
      repairTotal: 0,
      violationTotal: 0,
      faultTotal: 0,
      total: 0,

      dialogAddVisible: false,
      formLabelWidth: "112px",
      diaTitle: "",
      btnType: "",
      addRules: {
        carId: [
          {
            required: true,
            message: this.$t("TopBar.form.carId"),
            trigger: "blur",
          },
        ],
        contactName: [
          {
            required: true,
            message: this.$t("TopBar.form.contactName"),
            trigger: "blur",
          },
        ],
        happenTime: [
          {
            required: true,
            message: this.$t("TopBar.form.happenTime"),
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("TopBar.form.phone"),
            trigger: "blur",
          },
        ],
      },
      addForm: {
        carId: "",
        contactName: "",
        happenTime: "",
        phone: "",
        remarks: "",
        filePath: "",
      },
      imageUrl: "",
      dialogVisible: false,
      processImg: processApi,
      FileList: [],
      filePath: "",

      configList: [],
      listData: [],
      userProfile: "",
      newArr: "",
      show: true,

      count: '0',
      ws: null,
    };
  },
  created() {
    if (localStorage.getItem("locale") == "zh") {
      this.$i18n.locale = "zh";
      this.myVal = 0;
    } else {
      this.$i18n.locale = "en";
      this.myVal = 1;
    }
    this.user = sessionStorage.getItem("username");
    if (sessionStorage.getItem("userType") == 0) {
      this.show = true;
    } else {
      this.show = false;
    }
  },
  mounted() {
    this.ws = new WebSocket('wss://lyupback.langyuniot.com:8083/push');
    setTimeout(() => {
      this.sendMessage()
      this.ws.onmessage = (event) => {
        this.message = JSON.parse(event.data)
        this.count = this.message.count;
      };
    }, 1000)
  },
  methods: {
    sendMessage() {
      let message = {
        userId: sessionStorage.getItem("userId")
      }
      this.ws.send(JSON.stringify(message));
    },

    toggleFullScreen() {
      if (screenfull.isEnabled) {
        if (!screenfull.isFullscreen) {
          this.iFullScreen = !this.iFullScreen;
          screenfull.request();
        } else {
          this.iFullScreen = !this.iFullScreen;
          screenfull.exit();
        }
      } else {
        this.$message({
          message: this.$t("TopBar.form.yourBrowserDoesNotSupportFullScreen"),
          type: "warning",
        });
      }
    },
    toggleSideBar() {
      this.isCollapse = !this.isCollapse;
      this.$store.dispatch("menuTab/toggleSideBar", this.isCollapse);
    },
    changeLanguage(e) {
      console.log(e)
      let param = {
        userId: sessionStorage.getItem("userId"),
        language: e,
      };
      this.$store
        .dispatch("navMenu/GET_SWITCHLANGUAGE", param)
        .then((res) => {
          if (res.data.code == 200) {
            if (e === 0) {
              this.$i18n.locale = "zh";
              this.myVal = 0;
            } else {
              this.$i18n.locale = "en";
              this.myVal = 1;
            }
            localStorage.setItem("locale", this.$i18n.locale);
            window.location.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => { });
    },
    handleCommand(command) {
      if (command == "a") {
        this.dialogFormVisible = true;
      } else {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("username");
        sessionStorage.removeItem("menu");
        sessionStorage.removeItem("path");
        location.reload();
        this.$router.push("/login");
      }
    },
    changePass() {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            id: sessionStorage.getItem("userId"),
            loginPwd: this.form.loginPwd,
            oldPwd: this.form.oldPwd,
          };
          this.$store
            .dispatch("userManagement/GET_UPDATEUSERLOGINPWD", param)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('TopBar.passChangeSuccess'));
                this.dialogFormVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => { });
        } else {
          return false;
        }
      });
    },

    ListSetting() {
      this.$refs.listSet.dialogVisible = true;
    },
    changeCheck(e) {
      if (e) {
        this.userProfile = e.join(",");
      }
    },
    draggerEnd(val) {
      let arr = [];
      val.map((item) => {
        arr.push(item.id);
        this.userProfile = arr.join(",");
      });
    },
    changeSort(item) {
      let userProfile = "";
      let arr = [];
      item.map((items) => {
        if (items.check === 1) {
          arr.push(items.id);
          userProfile = arr.join(",");
        } else {
          userProfile = this.userProfile;
        }
      });
      this.configList = [];
      let param = {
        id: sessionStorage.getItem("userId"),
        userProfile: userProfile,
      };
      this.$store
        .dispatch("navMenu/GET_UPDATEUSERPROFILE", param)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(this.$t("common.btn.editSuccess"));
            this.getColumn();
            console.log(this.configList);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => { });
    },
    getColumn() {
      let param = {
        id: sessionStorage.getItem("userId"),
      };
      this.$store
        .dispatch("navMenu/GET_GETUSERPROFILE", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              res.data.data.map((item) => {
                if (item.check == 1) {
                  this.configList.push({
                    id: item.id,
                    profileName: item.profileName,
                    value: item.value,
                  });
                }
              });
              this.listData = res.data.data;
            }
          }
        })
        .catch((err) => { });
    },

    // btnRemind() {
    //   this.dialogRemindVisible = true;
    //   this.configList = [];
    //   this.AllColumns = this.repairColumns;
    //   // this.getOperateList();
    //   this.activeName = 'first'
    //   this.repairTotal = this.message.requestCount;
    //   this.violationTotal = this.message.violationCount
    //   this.faultTotal = this.message.faultCount
    //   this.getFault();
    //   this.getColumn();
    //   this.getRepairList();
    //   // this.getFaultList();
    //   // this.getViolationList();
    // },
    handleClick(event) {
      this.activeName = event.name;
      if (this.activeName == "first") {
        this.AllColumns = this.repairColumns;
        this.formTable = {
          number: "",
          eventCode: "",
          FaultTime: [],
          selectCarType: '',
          selectCarValue: '',
          MaintainTime: [],
        };
        this.getRepairList();
        // this.selectType = 0;
        // this.changeBackground = 0;
        // this.getFault();
      } else if (this.activeName == "second") {
        this.AllColumns = this.ViolationColumns;
        this.formTable = {
          number: "",
          eventCode: "",
          FaultTime: [],
          selectCarType: '',
          selectCarValue: '',
          MaintainTime: [],
        };
        this.selectType = 0;
        this.changeBackground = 0;
        this.getViolation();
        this.getViolationList();
      } else {
        this.AllColumns = this.FaultColumns;
        this.formTable = {
          number: "",
          eventCode: "",
          FaultTime: [],
          selectCarType: '',
          selectCarValue: '',
          MaintainTime: [],
        };
        this.selectType = 0;
        this.changeBackground = 0;
        this.getFault();
        this.getFaultList();
      }
    },
    getRepairList() {
      let startTime = ''
      let endTime = ''
      if (this.formTable.MaintainTime) {
        if (this.formTable.MaintainTime.length > 0) {
          startTime = this.formTable.MaintainTime[0]
          endTime = this.formTable.MaintainTime[1]
        }
      }
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        userId: sessionStorage.getItem("userId"),
        selectType: 0,
        selectCarType: this.formTable.selectCarType,
        selectCarValue: this.formTable.selectCarValue,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$store.dispatch('RepairManagement/GET_GETREPAIRLIST', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.authorizeList = res.data.data.list;
            this.$refs.AuthorizePage.CommandTotal = res.data.data.total;

          }
        }
      }).catch(err => { })
    },
    getFaultList() {
      let startTime = "";
      let endTime = "";
      if (this.formTable.FaultTime) {
        if (this.formTable.FaultTime.length > 0) {
          startTime = this.formTable.FaultTime[0];
          endTime = this.formTable.FaultTime[1];
        }
      }
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        selectType: this.selectType,
        number: this.formTable.number,
        eventCode: this.formTable.eventCode,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.AuthorizeCurrentPage,
        pageSize: this.AuthorizePageSize,
      };
      this.$store.dispatch("navMenu/GET_GETCARFAULT", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.authorizeList = res.data.data.list;
              this.$refs.AuthorizePage.CommandTotal = res.data.data.total;
              this.total = res.data.data.total

            }
          }
        }).catch((err) => { });
    },
    getViolationList() {
      let startTime = "";
      let endTime = "";
      if (this.formTable.FaultTime) {
        if (this.formTable.FaultTime.length > 0) {
          startTime = this.formTable.FaultTime[0];
          endTime = this.formTable.FaultTime[1];
        }
      }
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        selectType: this.selectType,
        number: this.formTable.number,
        eventCode: this.formTable.eventCode,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.AuthorizeCurrentPage,
        pageSize: this.AuthorizePageSize,
      };
      this.$store.dispatch("navMenu/GET_GETDRIVERVIOLATION", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.authorizeList = res.data.data.list;
              this.$refs.AuthorizePage.CommandTotal = res.data.data.total;
              this.total = res.data.data.total

            }
          }
        }).catch((err) => { });
    },
    // getOperateList() {
    //   if (this.activeName == "first") {
    //     getRepairList()
    //   } else if(this.activeName == "second") {

    //   } else {

    //   }
    // },
    closeOperateDia() {
      this.dialogOperateFormVisible = false;
    },
    Search() {
      this.$refs.AuthorizePage.CommandCurrentPage = 1;
      this.AuthorizeCurrentPage = 1;
      if (this.activeName == "first") {
        this.getRepairList();
      } else if (this.activeName == "second") {
        this.getViolationList();
      } else {
        this.getFaultList();
      }
    },
    Clear() {
      this.formTable = {
        number: "",
        eventCode: "",
        FaultTime: [],
        selectCarType: '',
        selectCarValue: '',
        MaintainTime: [],
      };
      if (this.activeName == "first") {
        this.getRepairList();
      } else if (this.activeName == "second") {
        this.getViolationList();
      } else {
        this.getFaultList();
      }
    },
    handleAuthorizeChange(val) {
      this.selected = val;
    },
    changeAuthorizeSize(item) {
      this.AuthorizePageSize = item.pageSize;
      this.AuthorizeCurrentPage = item.pageNum;
      this.getRepairList();
      this.getFaultList();
      this.getViolationList();
    },
    getFault() {
      this.$store
        .dispatch("navMenu/GET_SELECTFAULTTYPE", {})
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.faultList = res.data.data;
            }
          }
        })
        .catch((err) => { });
    },
    getViolation() {
      this.$store
        .dispatch("navMenu/GET_SELECTVIOLATIONTYPE", {})
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.violationList = res.data.data;
            }
          }
        })
        .catch((err) => { });
    },
    btnIgnore(type) {
      this.$confirm(
        this.$t("TopBar.form.confirmIgnore"),
        this.$t("common.btn.hint"),
        {
          cancelButtonText: this.$t("common.btn.cancel"),
          confirmButtonText: this.$t("common.btn.confirm"),
          type: "warning",
        }
      )
        .then((res) => {
          let id = "";
          if (type == "one") {
            id = this.stateId;
          } else {
            id = this.selected.map((item) => item.id).join();
          }
          let param = {
            id: id,
          };
          this.$store
            .dispatch("navMenu/GET_UPDAYEHANDLESTATE", param)
            .then((response) => {
              if (response.data.code == 200) {
                if (this.activeName == "second") {
                  this.getViolationList();
                } else if (this.activeName == "third") {
                  this.getFaultList();
                }
                this.$message.success(this.$t("TopBar.form.ignoreSuccess"));
              } else {
                this.$message.error(response.data.msg);
              }
            })
            .catch((error) => { });
        })
        .catch((err) => { });
    },
    deleteRepair() {
      this.$confirm(this.$t('common.AreYouSureAcceptOrder'), this.$t('common.btn.hint'),
        {
          cancelButtonText: this.$t('common.btn.cancel'),
          confirmButtonText: this.$t('common.btn.confirm'),
          type: 'warning'
        }).then(res => {
          let param = { requestSerialNumber: this.selected[0].requestSerialNumber, userId: sessionStorage.getItem("userId") }
          this.$store.dispatch('RepairManagement/GET_UPDATEREPAIRUSER', param).then(response => {
            if (response.data.code == 200) {
              this.getRepairList()
              this.$message.success(this.$t('common.OrderSuccess'))
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {

        })
    },

    submitAdd(addFormName) {
      this.$refs[addFormName].validate((valid) => {
        if (valid) {
          let param = {
            userId: sessionStorage.getItem("userId"),
            id: this.stateId,
            carId: this.addForm.carId,
            contactName: this.addForm.contactName,
            happenTime: this.addForm.happenTime,
            phone: this.addForm.phone,
            remarks: this.addForm.remarks,
            filePath: this.addForm.filePath,
          };
          this.$store
            .dispatch("navMenu/GET_INSERTREQUESTREPAIR", param)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('common.createSuccess'));
                this.dialogAddVisible = false;
                this.getFaultList();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => { });
        }
      });
    },
    handlePictureCardPreview(file) {
      this.imageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.FileList = [];
      const arr = [];
      fileList.map((item) => {
        this.FileList.push({
          name: item.name,
          url: item.url,
          uid: item.uid,
        });
        arr.push(item.url);
      });
      this.addForm.filePath = arr.join(",");
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      const arr = [];
      this.FileList.push({
        name: res.name,
        url: res.data[0],
        uid: res.uid,
      });
      this.FileList.map((item) => {
        console.log(item);
        arr.push(item.url);
      });
      this.addForm.filePath = arr.join(",");
    },
    cancle(formName) {
      this.dialogAddVisible = false;
      this.addForm = {
        carId: "",
        contactName: "",
        happenTime: "",
        phone: "",
        remarks: "",
        filePath: "",
      };
    },
    closeDia() {
      this.addForm = {
        carId: "",
        contactName: "",
        happenTime: "",
        phone: "",
        remarks: "",
        filePath: "",
      };
      this.dialogAddVisible = false;
    },

    btnPush() {
      this.$confirm(
        this.$t("TopBar.form.confirmPush"),
        this.$t("common.btn.hint"),
        {
          cancelButtonText: this.$t("common.btn.cancel"),
          confirmButtonText: this.$t("common.btn.confirm"),
          type: "warning",
        }
      )
        .then((res) => {
          let param = {
            id: this.stateId,
          };
          this.$store
            .dispatch("navMenu/GET_PUSHVIOLATION", param)
            .then((response) => {
              if (response.data.code == 200) {
                this.getViolationList();
                this.$message.success(this.$t("TopBar.form.pushSuccess"));
              } else {
                this.$message.error(response.data.msg);
              }
            })
            .catch((error) => { });
        })
        .catch((err) => { });
    },

    down() {
      if (this.activeName == "first") {
        let startTime = "";
        let endTime = "";
        if (this.formTable.FaultTime) {
          if (this.formTable.FaultTime.length > 0) {
            startTime = this.formTable.FaultTime[0];
            endTime = this.formTable.FaultTime[1];
          }
        }
        let orgId = sessionStorage.getItem("roleData");
        if (domainName) {
          if (domainName.split(":")[0] !== "localhost") {
            let url = `https://${domainName}/v1/getExportExcel/exportCarFault?orgId=${orgId}&selectType=${this.selectType}&number=${this.formTable.number}&eventCode=${this.formTable.eventCode}&startTime=${startTime}&endTime=${endTime}`;
            location.href = url;
          } else {
            let host = "localhost:8080";
            let url = `https://${host}/v1/getExportExcel/exportCarFault?orgId=${orgId}&selectType=${this.selectType}&number=${this.formTable.number}&eventCode=${this.formTable.eventCode}&startTime=${startTime}&endTime=${endTime}`;
            location.href = url;
          }
        }
      } else {
        let startTime = "";
        let endTime = "";
        if (this.formTable.FaultTime) {
          if (this.formTable.FaultTime.length > 0) {
            startTime = this.formTable.FaultTime[0];
            endTime = this.formTable.FaultTime[1];
          }
        }
        let orgId = sessionStorage.getItem("roleData");
        if (domainName) {
          if (domainName.split(":")[0] !== "localhost") {
            let url = `https://${domainName}/v1/getExportExcel/exportDriverViolation?orgId=${orgId}&selectType=${this.selectType}&number=${this.formTable.number}&eventCode=${this.formTable.eventCode}&startTime=${startTime}&endTime=${endTime}`;
            location.href = url;
          } else {
            let host = "localhost:8080";
            let url = `https://${host}/v1/getExportExcel/exportDriverViolation?orgId=${orgId}&selectType=${this.selectType}&number=${this.formTable.number}&eventCode=${this.formTable.eventCode}&startTime=${startTime}&endTime=${endTime}`;
            location.href = url;
          }
        }
      }
    },

    changeBtn(index) {
      if (this.activeName == "second") {
        if (index == 0) {
          this.selectType = 0;
          this.AllColumns = this.ViolationColumns;
        } else if (index == 1) {
          this.selectType = 1;
          let arr = this.ViolationColumns.filter(
            (item) => item.prop != "state"
          );
          this.AllColumns = arr;
          console.log(arr);
        } else {
          this.selectType = 2;
          let arr = this.ViolationColumns.filter(
            (item) => item.prop != "state"
          );
          this.AllColumns = arr;
        }
        this.getViolationList();
      } else if (this.activeName == "third") {
        if (index == 0) {
          this.selectType = 0;
          this.AllColumns = this.FaultColumns;
        } else if (index == 1) {
          this.selectType = 1;
          let arr = this.FaultColumns.filter((item) => item.prop != "state");
          this.AllColumns = arr;
          console.log(arr);
        } else {
          this.selectType = 2;
          let arr = this.FaultColumns.filter((item) => item.prop != "state");
          this.AllColumns = arr;
        }
        this.getFaultList();
      }
      this.changeBackground = index;

    },
  },
};
</script>

<style lang="less" scoped>
.navStyle {
  background-color: #081831;

  .nav-up {
    height: 45px;
    line-height: 45px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(173, 177, 195, 0.15);

    .up-left {
      display: flex;
      padding-left: 16px;
    }

    .up-right {
      padding-right: 16px;

      [class*=" el-icon-"],
      [class^="el-icon-"],
      .iconfont {
        color: #fff;
        margin-right: 15px;
      }

      /deep/ .el-badge {
        .el-badge__content.is-fixed {
          top: 12px;
          right: 24px;
        }

        .el-badge__content {
          border: none;
          padding: 0 4px;
        }
      }

      .leftBack-select {
        width: 80px;
        padding-right: 10px;

        /deep/.el-input__inner {
          height: 30px;
          line-height: 30px;
          background-color: transparent;
          color: #fff;
          border: none;
          border-radius: 2px;
          padding: 0 10px;
        }

        /deep/.el-input__icon {
          height: 30px;
          line-height: 30px;
        }

        /deep/.el-select__caret {
          color: #fff;
        }
      }

      .right-head {
        width: 15px;
        height: 15px;
        background: url("../../assets/images/person.png") no-repeat;
        background-size: 100% 100%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        margin-top: -4px;
      }

      .menuDialog {
        /deep/.el-dialog {
          .el-dialog__header {
            padding: 0 20px;
            background-color: #409eff;

            .el-dialog__title {
              color: #fff;
            }

            .el-dialog__headerbtn {
              top: 12px;

              .el-dialog__close {
                color: #fff;
                font-size: 20px;
              }
            }
          }

          .el-dialog__body {
            padding: 20px;

            .el-form-item {
              margin-bottom: 20px;

              .el-form-item__label {
                color: #333;
                padding-right: 10px;
                line-height: 30px;
              }

              .el-form-item__content {
                line-height: 30px;

                .el-input {
                  width: 380px;

                  .el-input__inner {
                    width: 380px;
                    height: 30px;
                    line-height: 30px;
                    padding: 0 10px;
                    border-color: #b8b8b8;
                    color: #333;
                  }

                  ::-webkit-input-placeholder {
                    color: #84858b;
                  }
                }

                .el-button {
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  padding: 0;
                  border-radius: 2px;
                  font-size: 14px;
                  background-color: #ffa230;
                  color: #fff;
                  border: none;
                  margin-left: 10px;
                }
              }
            }

            .dialogNotice {
              .noticeConfig {
                .configFlex {
                  display: flex;
                  justify-content: space-between;
                  padding: 0 30px;
                  border: 1px solid #409eff;

                  .flexStyle {
                    text-align: center;
                    padding: 20px 0;

                    .flexValue {
                      color: #333;
                      font-size: 28px;
                      font-weight: bold;
                      line-height: 28px;
                    }

                    .flexName {
                      color: #333;
                      font-size: 14px;
                      line-height: 28px;
                    }
                  }
                }
              }

              .noticeTab {
                .zMsgSearch {
                  .el-form {
                    .el-form-item {
                      margin-bottom: 0;
                      margin-right: 20px;
                      height: 30px;
                      line-height: 30px;

                      .el-form-item__label {
                        color: #333 !important;
                        padding-right: 10px;
                        font-size: 14px;
                        line-height: 30px;
                      }

                      .el-form-item__content {
                        line-height: 30px;
                        vertical-align: middle;

                        .el-input {
                          width: 150px;

                          .el-input__inner {
                            width: 150px;
                            font-size: 14px;
                            height: 30px;
                            padding: 0 10px;
                            border-color: #adb1c3;
                            border-radius: 2px;
                            background-color: transparent;
                            color: #333;
                          }
                        }

                        .el-select {
                          .el-input {
                            width: 120px;

                            .el-input__inner {
                              width: 120px;
                            }
                          }
                        }

                        .el-ranputStylenge-editor--mini .el-range-input,
                        .el-date-editor .el-range-input {
                          font-size: 14px;
                          color: #333;
                          background-color: transparent;
                        }

                        .el-range-editor.el-input__inner {
                          width: 300px !important;
                          background-color: transparent;
                          border-color: #adb1c3;
                          border-radius: 2px;
                        }
                      }

                      .el-button {
                        font-size: 14px;
                        width: 64px;
                        height: 30px;
                      }

                      .btn-chaxun {
                        background-color: #409eff;
                        border-color: transparent;
                        border-radius: 2px;
                      }

                      .btn-del {
                        background-color: transparent;
                        color: #adb1c3;
                        border: 1px solid #adb1c3;
                        border-radius: 2px;
                      }
                    }
                  }
                }

                .zMsgBtn {
                  display: flex;
                  justify-content: space-between;

                  .btnLeft {
                    .btnStyle {
                      span {
                        padding-right: 20px;

                        [class^="el-icon-"] {
                          margin-right: 5px;
                          color: #999;
                        }
                      }

                      .btnBackground {
                        color: #409eff;

                        [class^="el-icon-"] {
                          color: #409eff;
                        }
                      }
                    }
                  }

                  .btnRight {
                    .el-button {
                      padding: 0;
                    }
                  }
                }

                .zMsgTable {
                  .el-table {
                    background-color: transparent;

                    th {
                      font-size: 14px;
                      color: #333;
                      background-color: #e8e8e8;
                      padding: 0;
                      height: 40px;
                    }

                    tr {
                      background-color: #fff;
                    }

                    tr:hover>td {
                      background-color: #fff;
                    }

                    td {
                      font-size: 13px;
                      color: #333;
                      height: 35px;
                      padding: 0;

                      .el-tag {
                        background-color: transparent;
                        font-size: 13px;
                        height: 24px;
                        line-height: 24px;
                        border: none !important;
                      }
                    }

                    .el-button {
                      background-color: transparent;
                      border: none;
                      border-radius: 0;
                      color: #409eff;
                      padding: 0;
                    }

                    .el-button.is-disabled,
                    .el-button.is-disabled:focus,
                    .el-button.is-disabled:hover {
                      color: #c0c4cc;
                    }

                    .el-checkbox__inner {
                      border-color: #697c97;
                      background-color: transparent;
                      border-radius: 0;
                    }

                    .el-checkbox__input.is-checked .el-checkbox__inner,
                    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                      background-color: #409eff;
                      border-color: #409eff;
                    }

                    .el-checkbox__input.is-focus .el-checkbox__inner {
                      border-color: #409eff;
                    }

                    .el-table__body tr.hover-row>td {
                      background-color: transparent !important;
                    }

                    .el-icon-document-add:before,
                    .el-icon-delete:before {
                      color: #409eff;
                      font-size: 14px;
                    }
                  }

                  .el-table--striped .el-table__body tr.el-table__row--striped td {
                    background-color: #efefef !important;
                  }

                  .el-table__fixed-body-wrapper {
                    top: 46px !important;
                  }

                  .el-pagination {
                    span:not([class*="suffix"]) {
                      line-height: 24px;
                    }

                    .el-pagination__total {
                      font-size: 14px;
                      color: #333;
                      line-height: 24px;
                      margin-right: 0;
                    }

                    .el-pagination__sizes {
                      margin: 0;

                      .el-input__inner {
                        font-size: 14px;
                        color: #333;
                        text-align: left;
                        padding: 0 10px;
                        height: 24px;
                        width: 90px;
                        background-color: transparent;
                        border-radius: 0;
                        border-color: #7f8791;
                      }
                    }

                    .btn-prev,
                    .btn-next {
                      min-width: 24px;
                      height: 24px;
                      background-color: transparent;
                      border: 1px solid #7f8791;
                      color: #333;
                      border-radius: 0;
                    }

                    .el-pager li {
                      min-width: 24px;
                      height: 24px;
                      line-height: 24px;
                      border-radius: 0;
                      background-color: transparent;
                      border: 1px solid #7f8791;
                      color: #333;
                    }

                    .el-pager li:not(.disabled).active {
                      border: none;
                      background-color: #409eff;
                      color: #fff;
                    }

                    .el-pagination__jump {
                      margin-left: 15px;
                      font-size: 14px;
                      color: #333;

                      .el-input__inner {
                        width: 40px;
                        height: 24px;
                        line-height: 24px;
                        background-color: transparent;
                        border-radius: 0;
                        border-color: #7f8791;
                        color: #333;
                      }
                    }
                  }
                }
              }
            }
          }

          .el-dialog__footer {
            padding: 0 20px 30px;

            .el-button {
              font-size: 14px;
              width: 64px;
              height: 30px;
              padding: 0;
              border-radius: 2px;
            }
          }
        }
      }
    }
  }

  .nav-down {
    margin-top: 8px;
    padding: 0 16px;
  }
}
</style>
